import {charcoal} from '../sass/base/_exports.sass';

export const MessageLineIconSent = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {
    height: `${ratio * height}px`,
    width: `${ratio * width}px`,
  };

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.941406 10.941406 L 21.058594 9.058594 L 14.667969 15.449219 L 11.609375 12.390625 L 9.722656 14.277344 L 14.667969 19.21875 Z M 22.941406 10.941406"
        fill={color}
      />
      <path
        d="M26.667969 2.667969 L 5.332031 2.667969 C 3.863281 2.667969 2.667969 3.863281 2.667969 5.332031 L 2.667969 29.332031 L 9.777344 24 L 26.667969 24 C 28.136719 24 29.332031 22.804688 29.332031 21.332031 L 29.332031 5.332031 C 29.332031 3.863281 28.136719 2.667969 26.667969 2.667969 Z M 26.667969 21.332031 L 8.890625 21.332031 L 5.332031 24 L 5.332031 5.332031 L 26.667969 5.332031 Z M 26.667969 21.332031"
        fill={color}
      />
    </svg>
  );
};
